import React from 'react'
// components
import AvatarUpload from '../AvatarUpload'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AccordionOrigin from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import { ReduxInput, ReduxSelect, ReduxSwitch, ReduxDatePicker } from 'components/FormElements/ReduxForm'
// hooks
import { useCurrentUser } from 'hooks/useCurrentUser'
// constants
import { LANGUAGE_OPTIONS } from 'constants/countries'
import { USER_GENDER_OPTIONS } from 'constants/users'
// themes
import LocationSection from 'components/FormElements/ReduxForm/Forms/BusinessEntitiesForm/components/LocationSection'
import { Forms } from 'constants/forms'
import { colors } from 'themes/index'
// views
import { BottomSection, PhonesDescription, PhonesSection, TopSection, TopSectionFields } from '../../views'
// utils
import { email, normalizePhone, phone, required } from 'utils/validators'
import { generateTimezoneOptions } from 'utils/date'
import { getPhoneExample } from 'utils/phone'

export const PANEL_STYLES = {
  display: 'flex',
  flexDirection: 'column',
  padding: '8px 24px 36px 24px',
  gap: 16
} as React.CSSProperties

const UserData: React.FC<any> = ({ avatar, onAvatarUpload }) => {
  const { company } = useCurrentUser()
  // Example follows the company's country (e.g. +61 for Australia, +380 for Ukraine).
  const phoneExample = getPhoneExample(company?.geoLocation?.country)
  const phoneValidator = React.useMemo(() => [phone(phoneExample)], [phoneExample])

  return (
    <AccordionOrigin defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor={colors.blue500} />}>User data</AccordionSummary>
      <AccordionDetails style={PANEL_STYLES}>
        <TopSection>
          <TopSectionFields>
            <ReduxSwitch name='active' label='Active' />
            <ReduxInput name='firstName' label='First Name' validate={[required]} />
            <ReduxInput name='middleName' label='Middle Name' />
            <ReduxInput name='lastName' label='Surname' validate={[required]} />
            <ReduxInput name='displayName' label='Display Name' />
            <ReduxDatePicker name='dateOfBirth' label='Date of Birth' />
          </TopSectionFields>
          <AvatarUpload avatar={avatar} onUpload={onAvatarUpload} description='Change your profile picture' />
        </TopSection>

        <BottomSection>
          <ReduxSelect label='Gender' name='gender' options={USER_GENDER_OPTIONS} />
          <LocationSection form={Forms.USER_DETAILS_EDIT_FORM} label='User' showCoordinates={false} />
          <ReduxSelect label='Preferred Language' name='language' options={LANGUAGE_OPTIONS} />
          <ReduxSelect label='Time Zone' name='timezone' options={generateTimezoneOptions()} />
          <PhonesDescription>Use international format, e.g. {phoneExample}</PhonesDescription>
          <PhonesSection>
            <ReduxInput
              label='Home Phone'
              name='homePhone'
              placeholder={phoneExample}
              validate={phoneValidator}
              normalize={normalizePhone}
            />
            <ReduxInput
              label='Mobile Phone'
              name='mobilePhone'
              placeholder={phoneExample}
              validate={phoneValidator}
              normalize={normalizePhone}
            />
            <ReduxInput
              label='Work Phone'
              name='workPhone'
              placeholder={phoneExample}
              validate={phoneValidator}
              normalize={normalizePhone}
            />
          </PhonesSection>
          <ReduxInput label='Email' name='email' type='email' validate={[email, required]} />
          <ReduxInput label='Alternate Email' type='email' name='alternateEmail' />
        </BottomSection>
      </AccordionDetails>
    </AccordionOrigin>
  )
}

export default UserData
